function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import player from 'youtube-player';
import Modal from '../modules/lg/modal';
var IplexModal = /*#__PURE__*/function () {
  function IplexModal() {
    _classCallCheck(this, IplexModal);
    this.initModal();
  }
  _createClass(IplexModal, [{
    key: "initModal",
    value: function initModal() {
      var _this = this;
      this.galleryImageModal = new Modal({
        triggerClass: 'js-gallery-modal-trigger',
        clickOutsideToClose: false,
        onOpen: function onOpen() {
          var enlargedImage = document.getElementById('EnlargedImage');
          var trigger = _this.galleryImageModal.getEventTarget();
          var imageUrl = trigger.dataset.enlargeurl;
          var imageTitle = trigger.dataset.enlargetitle;
          if (enlargedImage) {
            enlargedImage.src = imageUrl;
            enlargedImage.alt = imageTitle;
          }
        }
      });
      this.galleryImageModal.bindEvents();
      this.enquiryModal = new Modal({
        triggerClass: 'js-enquiry-modal-trigger',
        clickOutsideToClose: false,
        onOpen: function onOpen() {
          var trigger = _this.enquiryModal.getEventTarget();
          var productName = trigger.dataset.productname;
          var productCode = trigger.dataset.productcode;
          var productInput = document.getElementById('EnquiryProduct');
          if (productInput) {
            productInput.value = "Product: ".concat(productName || '', " ").concat(productCode || '');
          }
        }
      });
      this.enquiryModal.bindEvents();
      var resourceVideo;
      this.videoModal = new Modal({
        triggerClass: 'js-video-modal-trigger',
        clickOutsideToClose: false,
        onOpen: function onOpen() {
          var trigger = _this.videoModal.getEventTarget();
          var youtubeID = IplexModal.youtubeParser(trigger.href);
          resourceVideo = player('ResourceVideo', {
            videoId: youtubeID
          });
        },
        afterOpen: function afterOpen() {
          resourceVideo.playVideo();
        },
        onClose: function onClose() {
          resourceVideo.pauseVideo();
        }
      });
      this.videoModal.bindEvents();
    }
  }], [{
    key: "youtubeParser",
    value: function youtubeParser(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : false;
    }
  }]);
  return IplexModal;
}();
export { IplexModal as default };